import { render } from "./LaputaImageBanner.vue?vue&type=template&id=2ef186d8&scoped=true"
import script from "./LaputaImageBanner.vue?vue&type=script&lang=js"
export * from "./LaputaImageBanner.vue?vue&type=script&lang=js"

import "./LaputaImageBanner.vue?vue&type=style&index=0&id=2ef186d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef186d8"]])

export default __exports__